import { Box, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { cloneElement } from "react";

export default function BudgetSummaryTile({
	title,
	budget,
	actual,
	icon,
	color,
}) {
	const theme = useTheme();
	const { t } = useTranslation();
	const userCurrency = localStorage.getItem("userCurrency");

	const formatAmount = (value) => {
		if (value === null || value === undefined) return "";
		return new Intl.NumberFormat("pl-PL", {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(value);
	};

	const tileStyles = {
		flexGrow: 1,
		display: "flex",
		flexDirection: "column",
		gap: 1,
		bgcolor: theme.palette.background.paper,
		borderRadius: "10px",
		alignItems: "center",
		justifyContent: actual !== null ? "space-between" : "flex-start",
		p: 2,
	};

	const textStyles = {
		marginBottom: 0,
		width: "100%",
	};

	return (
		<Box sx={tileStyles}>
			<Typography
				variant="body2"
				component="div"
				sx={{ ...textStyles, color: theme.palette.text.secondary }}
			>
				{title}
			</Typography>
			<Box
				sx={{
					width: "100%",
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<Typography
					variant="h5"
					sx={{
						...textStyles,
						color,
						fontWeight: "bold",
					}}
				>
					{formatAmount(actual !== null ? actual : budget)}{" "}
					{userCurrency}
				</Typography>

				{icon &&
					cloneElement(icon, {
						sx: {
							fontSize: "2rem",
							color,
						},
					})}
			</Box>

			{actual !== null && (
				<Typography variant="subtitle1" sx={textStyles}>
					{`${t("budget")}: ${formatAmount(budget)} ${userCurrency}`}
				</Typography>
			)}
		</Box>
	);
}
